import { PwsMediaConfigTab, PwsMediaEpisode } from "@inferno/renderer-shared-core";

export const EPISODES_PER_TAB = 12;

class LinkedListNode<T> {
  constructor(public data: T, public next: LinkedListNode<T> | null = null) {}
}

class LinkedList<T> {
  head: LinkedListNode<T> | null = null;
  tail: LinkedListNode<T> | null = null;
  size = 0;

  constructor(head: LinkedListNode<T> | null = null) {
    if (head) {
      this.head = head;
      this.tail = head;
      this.size = 1;
    }
  }

  append(node: LinkedListNode<T>) {
    this.size++;

    if (!this.head || !this.tail) {
      this.head = node;
      this.tail = node;
    } else {
      this.tail.next = node;
      this.tail = this.tail.next;
    }

    return this;
  }

  appendData(data: T) {
    return this.append(new LinkedListNode(data));
  }

  appendMany(nodes: LinkedListNode<T>[]) {
    nodes.forEach(node => {
      this.append(node);
    });

    return this;
  }

  appendDataMany(list: T[]) {
    list.forEach(data => this.append(new LinkedListNode(data)));
    return this;
  }

  prepend(node: LinkedListNode<T>) {
    this.size++;

    if (!this.head || !this.tail) {
      this.head = node;
      this.tail = node;
    } else {
      node.next = this.head;
      this.head = node;
    }

    return this;
  }

  prependData(data: T) {
    return this.prepend(new LinkedListNode(data));
  }

  find(cb: (v: LinkedListNode<T>["data"]) => boolean) {
    let cur = this.head;

    while (cur) {
      if (cb(cur.data)) {
        return cur;
      }

      cur = cur.next;
    }
  }
}

export class CoastMediaEpisodeNode extends LinkedListNode<PwsMediaEpisode> {
  constructor(public data: PwsMediaEpisode, public next: CoastMediaEpisodeNode | null = null) {
    super(data, next);
  }
}

export class CoastMediaEpisodesList extends LinkedList<PwsMediaEpisode> {
  constructor(head: LinkedListNode<PwsMediaEpisode> | null = null) {
    super(head);
  }

  get pageCount() {
    return Math.ceil(this.size / EPISODES_PER_TAB) || 1;
  }

  getEpisodesForPage = (page: number) => {
    const episodesArray: CoastMediaEpisodeNode[] = [];

    const fromIdx = (page - 1) * EPISODES_PER_TAB;
    const toIdx = page * EPISODES_PER_TAB;
    let curNode = this.head;

    for (let idx = 0; idx < toIdx && curNode; idx++) {
      if (idx >= fromIdx) {
        episodesArray.push(curNode);
      }

      curNode = curNode?.next;
    }

    return episodesArray;
  };
}

export interface CoastMediaTabConfig extends Omit<PwsMediaConfigTab, "videos"> {
  episodesLL: CoastMediaEpisodesList;
  enablePagination: boolean;
}

export const episodesToLinkedList = (episodes: PwsMediaEpisode[]) => {
  return new CoastMediaEpisodesList().appendDataMany(episodes);
};
